import ProductItems from '@/app/components/ui/ProductComponent/ProductItems';
import ProductHeader from '@/app/components/ui/ProductHeader';
import { SvgLinesComponent } from '@/app/components/ui/SvgLinesComponent';
import { paddingClasses } from '@/app/lib/utils/getPaddingClasses';
import renderBackground from '@/app/lib/utils/renderBackground';
import type { ContenfulProductComponent } from '@/app/types/contentful/types';

export default function ProductComponent({ content }: { content: ContenfulProductComponent }) {
  const {
    productComponent: { title, description, showGridLines, backgroundType, spacingTop, spacingBottom },
  }: ContenfulProductComponent = content;

  const paddingTop = paddingClasses.top?.[spacingTop as keyof typeof paddingClasses.top] || 'pt-4';
  const paddingBottom = paddingClasses.bottom?.[spacingBottom as keyof typeof paddingClasses.bottom] || 'pb-4';

  return (
    <section className="relative" aria-labelledby="product-section-title">
      {showGridLines && (
        <div className="absolute left-0 top-0 -z-10 h-full w-full" aria-hidden="true">
          <SvgLinesComponent />
        </div>
      )}
      {renderBackground(backgroundType)}

      <div className={`${paddingTop} ${paddingBottom} container grid grid-cols-12 gap-y-10`}>
        {/* Product Header */}
        <ProductHeader title={title} description={description} />

        {/* Product Item */}
        <ProductItems />
      </div>
    </section>
  );
}
